var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPaySuccess = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 72, height: 72, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M36 4.5c17.395 0 31.5 14.105 31.5 31.5S53.395 67.5 36 67.5 4.5 53.395 4.5 36 18.605 4.5 36 4.5Zm-5.288 38.57-10.5-11.117-3 3.176 13.5 14.295 22.5-23.824-3-3.176-19.5 20.646Z", fill: "#6E9D6F" }));
export { SvgPaySuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2IDQuNWMxNy4zOTUgMCAzMS41IDE0LjEwNSAzMS41IDMxLjVTNTMuMzk1IDY3LjUgMzYgNjcuNSA0LjUgNTMuMzk1IDQuNSAzNiAxOC42MDUgNC41IDM2IDQuNVptLTUuMjg4IDM4LjU3LTEwLjUtMTEuMTE3LTMgMy4xNzYgMTMuNSAxNC4yOTUgMjIuNS0yMy44MjQtMy0zLjE3Ni0xOS41IDIwLjY0NloiIGZpbGw9IiM2RTlENkYiLz48L3N2Zz4=";
